import React from "react";

import { RowActionButton } from "../../../components/toolbars/RowActionButton";
import { NotifStatus } from "../../../entities/NotifStatus";


const MAX_SENT_ATTEMPTS = 3;

const isResendable = (record) => record.sent_attempts >= MAX_SENT_ATTEMPTS && record.status === NotifStatus.failed;

export const ResendButton = ({ resource, record }) => (
	<RowActionButton
		resource={resource}
		record={record}
		action="resend"
		label="osfc.buttons.resend"
		isEnabled={isResendable}
	/>
);
